<template>
  <div>
    <h2>{{ i18n.t('/PurchaseOrder/Bestelling') }}</h2>
    <app-fieldset title="Bestelling" class="order">
      <form-input
        id="car-amount"
        v-model.trim.lazy="v$.tempAmount.$model"
        class-name="car-amount"
        type="number"
        min="1"
        :max="maxCarAmount"
        :title="i18n.t('/PurchaseOrder/AantalAutos')"
        :error-message="errorMessage"
        :value="carAmount"
        @change="changeAmount"
      />

      <form-textarea
        id="komNumbers"
        v-model="komNumbers"
        class-name="komNumbers"
        :title="i18n.t('/PurchaseOrder/KomNumbers')"
        name="komNumbers"
        rows="5"
        readonly
      />

      <form-textarea
        id="remark"
        v-model="tempRemark"
        class-name="remark"
        :title="i18n.t('/PurchaseOrder/Opmerkingen')"
        name="remark"
        rows="5"
        @change="$emit('change-remark', tempRemark)"
      />
    </app-fieldset>
  </div>
</template>

<script>
import AppFieldset from '@/components/generic/presentational/atoms/appFieldset/AppFieldset.vue'
import FormInput from '@/components/generic/presentational/atoms/formInput/FormInput.vue'
import FormTextarea from '@/components/generic/presentational/atoms/formTextarea/FormTextarea.vue'
import { required, numeric, minValue, maxValue } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { mapState } from 'vuex'

export default {
  components: {
    AppFieldset,
    FormInput,
    FormTextarea,
  },
  validations() {
    return {
      tempAmount: {
        required,
        numeric,
        minValue: minValue(1),
        maxValue: maxValue(this.maxCarAmount),
      },
    }
  },
  props: {
    carAmount: {
      type: Number,
      default: 1,
    },
    remark: {
      type: String,
      default: '',
    },
    carStatuses: {
      type: Array,
      default: () => {},
    },
  },
  emits: ['change-remark', 'change-car-amount'],
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      tempRemark: null,
      tempAmount: null,
    }
  },
  computed: {
    ...mapState('user', ['dealerSettings']),
    maxCarAmount() {
      return this.dealerSettings?.isImporter ? 300 : 99
    },
    errorMessage() {
      if (!this.v$.tempAmount.$errors.length > 0) {
        return ''
      }

      if (!this.v$.tempAmount.required.$response) {
        return this.i18n.t('/PurchaseOrder/AantalVeldIsVerplicht')
      } else if (!this.v$.tempAmount.numeric.$response) {
        return this.i18n.t('/PurchaseOrder/AantalVeldIsNietGeldig')
      } else if (!this.v$.tempAmount.minValue.$response) {
        return this.i18n.t('/PurchaseOrder/AantalVeldIsNietGeldig')
      } else if (!this.v$.tempAmount.maxValue.$response) {
        return this.i18n.t('/PurchaseOrder/AantalVeldMaximumBereikt', {
          amount: this.maxCarAmount,
        })
      }
      return ''
    },
    komNumbers() {
      if (this.carStatuses) {
        return this.carStatuses
          .filter((status) => status?.KOMNumber?.Number)
          .map((status) => {
            return (
              status.KOMNumber.Number + (status.KOMNumber.Year ? '-' + status.KOMNumber.Year : '')
            )
          })
          .join('\r\n')
      }
      return null
    },
  },
  watch: {
    carAmount(value) {
      this.tempAmount = value
    },
    remark(value) {
      this.tempRemark = value
    },
  },
  created() {
    this.tempAmount = this.carAmount
    this.tempRemark = this.remark
  },
  methods: {
    changeAmount() {
      if (!this.v$.tempAmount.$errors.length > 0) {
        this.$emit('change-car-amount', this.tempAmount)
      } else {
        this.$emit('change-car-amount')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
h2 {
  font-size: 1.46191rem;
  margin-bottom: var(--space-xxs);
}
</style>
